import { Head } from "@inertiajs/react"
import { AppLayout } from "../../components/layout/AppLayout"
import { UserForm } from "../../features/users/UserForm"

type EditUserPageProps = {
  user: {
    id: number
    email: string
    password: string
    password_confirmation: string
  }
  errors?: Record<string, string[]>
}

export default function EditUserPage({ user, errors }: EditUserPageProps) {
  return (
    <>
      <Head title="Editar Usuário" />
      <AppLayout>
        <div className="mx-auto w-full max-w-6xl p-8">
          <div className="mb-6">
            <h1 className="text-3xl font-bold text-white">Editar Usuário</h1>
            <p className="text-slate-400">Atualize e-mail e senha do usuário.</p>
          </div>
          <UserForm
            initialValues={user}
            submitUrl={`/usuarios/${user.id}`}
            submitLabel="Salvar alterações"
            method="patch"
            errors={errors}
          />
        </div>
      </AppLayout>
    </>
  )
}
